module.exports = __webpack_public_path__ + "img/book.05714b88.svg";